import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { Sheet, SheetContent } from '@/components/ui/sheet'
import { SkipLink } from '@/components/ui/skip-link'
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts'
import { KeyboardShortcutsModal } from '@/components/KeyboardShortcutsModal'

export function DashboardLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [showShortcutsModal, setShowShortcutsModal] = useState(false)
  const { shortcuts } = useKeyboardShortcuts({
    onShowShortcuts: () => setShowShortcutsModal(true),
  })

  return (
    <div className="flex h-screen bg-background bg-grain">
      <SkipLink />
      {/* Desktop Sidebar - hidden on mobile */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Mobile Sheet */}
      <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
        <SheetContent side="left" className="p-0 w-64">
          <Sidebar mobile onNavigate={() => setMobileMenuOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Main content area */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header
          onMenuClick={() => setMobileMenuOpen(true)}
          onShowShortcuts={() => setShowShortcutsModal(true)}
        />
        <main id="main-content" tabIndex={-1} className="flex-1 overflow-auto p-6 md:p-8 bg-gradient-mesh">
          <Outlet />
        </main>
      </div>

      {/* Keyboard Shortcuts Modal */}
      <KeyboardShortcutsModal
        open={showShortcutsModal}
        onOpenChange={setShowShortcutsModal}
        shortcuts={shortcuts}
      />
    </div>
  )
}
